import { FC } from 'react';

import styled from '@emotion/styled';
import { Exam } from 'store/payment/paymentAPI';

import { Card } from '@britishcouncil/react-solas-ors3';

export const ExamCard: FC<{ exam: Exam }> = ({ exam }) => (
  <Card>
    <h3>
      {exam.syllabusName} - {exam.subjectName} <div style={{ float: 'right' }}>(in {exam.districtName})</div>{' '}
    </h3>
    {exam.components.length > 0 && (
      <>
        <b>Exam Component:</b>
        <StyledList>
          {exam.components.map((x, i) => (
            <li key={i}>{x}</li>
          ))}
        </StyledList>
      </>
    )}
    <PriceLabel>
      Price:{' '}
      <strong>
        {exam.offlinePaymentFee ? exam.offlinePaymentFee.toFixed(2) : exam.fee.toFixed(2)} {exam.currencyCode}
      </strong>
    </PriceLabel>
  </Card>
);

const StyledList = styled.ul`
  list-style: none;
  margin: 10px 0 0 0;
  font-size: 16px;

  li {
    padding: 0;
  }
`;

const PriceLabel = styled.p`
  text-align: right;
  margin-bottom: 0;
`;
